/**
 * Is valid key
 */
export function isValidKey(k: string | number, o: object): k is keyof typeof o {
  return k in o
}

/**
 * Launch app url
 * @param url (scheme)
 */
export function launchApp(url: string) {
  return new Promise((resolve, reject) => {
    let timer
    let flag = false
    let evt = 'visibilitychange'

    const pageVisible = () => {
      flag = true
      if (document.hidden) resolve && resolve(true)
      document.removeEventListener(evt, pageVisible)
    }

    document.addEventListener(evt, pageVisible, false)

    timer = setTimeout(() => {
      clearTimeout(timer)
      document.removeEventListener(evt, pageVisible)
      !flag && reject && reject()
    }, 2000)

    // location
    ;(window.top.location || window.location).href = url
  })
}

export const setImageThumbnail = (url: string = "", scale: number = 40): string => {
	if (!url || !url.startsWith("http")) return url;
	let index = url.indexOf("?");
	const query = `?imageMogr2/thumbnail/!${scale}p`;
	if (index > -1) return `${url.substring(0, index)}${query}`;
	return `${url}${query}`;
};
